var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-section',{attrs:{"collapsible":"","collapsed":"","help-collapsed":_vm.sectionHelp,"title":_vm.sectionTitle}},[_c('Details',{attrs:{"recPayData":_vm.recPayData}}),_c('InvoiceList',{attrs:{"recPayData":_vm.recPayData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }